
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advisory-board",
      function () {
        return require("private-next-pages/advisory-board.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advisory-board"])
      });
    }
  